import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { FiberManualRecord } from "@mui/icons-material";

export const AccountPending = () => {
  return (
    <Box
    >
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'center', flexWrap: 'wrap', height: '85vh' }}>
        <CircularProgress />
      </Box>
      <Stack direction="row" spacing={2} sx={{ margin: 'auto', width: '90%'}}>
        <FiberManualRecord sx={{ color: "primary.main" }} />
        <Typography>
          Verification pending, Check back in a few minutes.
        </Typography>
      </Stack>
    </Box>
  );
};
